import { isOpenQuoteAndOrderCalendarModal } from "@/atoms/is-open-quote-and-order-calendar-modal";
import { quoteAndOrderDurationState } from "@/atoms/quote-and-order-duration-state";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { PartnerManageOrderCalendarModal } from "../modal/PartnerManageOrderCalendarModal";

export const PartnerManageOrderPageModalPanel = () => {
  const [modal, setModal] = useRecoilState(isOpenQuoteAndOrderCalendarModal);
  const [selectedDuration, setSelectedDuration] = useRecoilState(
    quoteAndOrderDurationState
  );

  useEffect(() => {
    setModal({ open: false, startDate: undefined, endDate: undefined });
    setSelectedDuration({ startDate: undefined, endDate: undefined });
  }, []);

  return (
    <>
      <PartnerManageOrderCalendarModal />
    </>
  );
};
